import styled from '@emotion/styled';

export const SadaDashboard = styled.div``;
